import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react"

import { SignInContent } from "./SignInContent"
import { SignInProvider } from "./SignInContext"

export function SessionTimeoutSignIn() {
  return (
    <Dialog open onClose={() => {}} className="z-50">
      <DialogBackdrop className="dark:bg-gray-1000/75 fixed inset-0 z-50 bg-gray-500/75" />

      <div className="fixed inset-0 z-50 flex w-screen items-center justify-center">
        <SignInProvider initialStep="session-timeout">
          <DialogPanel as={SignInContent} />
        </SignInProvider>
      </div>
    </Dialog>
  )
}
